import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'lg', align: 'center' },
  }, overrideReadOnly);

export const tidBitMetaOverrideSet = buildBaseOverrides()
  .nameOverride('name', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md', align: 'center' },
  }, overrideReadOnly);
